import { useContext } from 'react';
import { LayoutProviderContext } from '../contexts/LayoutContext';

// ----------------------------------------------------------------------

const useLayoutContext = () => useContext(LayoutProviderContext);

export default useLayoutContext;
